import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { RoleProps } from "./types";

const Role = ({ roles }: RoleProps) => {
    const { t } = useTranslation();

    return (
        <>
            <span>{t("Table##role")}:</span>

            <span>
                <ul
                    css={css({
                        paddingLeft: "16px"
                    })}
                >
                    {roles.map(({ id, name }) => (
                        <li
                            key={id}
                            css={css({
                                listStyleType: "revert",
                                maxWidth: "500px"
                            })}
                        >
                            {name}
                        </li>
                    ))}
                </ul>
            </span>
        </>
    );
};

export default Role;
